import { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import NominaNoResumen from "../cardsNoResumen/NominaNoResumen";
import IRPFNoResumen from "../cardsNoResumen/IRPFNoResumen";


// import InfoEx from "../cards/InfoEx";
// import { esHabilitado } from "../../services/CertificadoINFOEXService";

// import Placeholder from "../cards/Placeholder";
// import ErrorConexion from "../cards/ErrorConexion";
import MisActosAdminCard from "../cardsNoResumen/MisActosAdminCard";
import IRPFHabilitadoNuevo from "../cards/IRPFHabilitadoNuevo";
//import HojaServiciosPrestadosCard from "../cardsNoResumen/HojaServiciosPrestadosCard";

const MisDatos = () => {
  // const [cargado, setCargado] = useState(false);
  const [isVisible, initHs] = useState(true);
  const [INFOEX_habilitado] = useState({
    habilitado: null,
  });
  // const [IRPFHABILITACIONES_habilitado, setIRPFHABILITACIONES_Habilitado] =
  //   useState({ habilitado: true });
  const [error_INFOEX] = useState(false);
  // const [error_IRPFHABILITACIONES, setError_IRPFHABILITACIONES] =
  //   useState(false);

  const invokeCollapse = () => {
    return initHs(!isVisible);
  };

  // useEffect(() => {
  //   const cargarDatos = async () => {
  //     // Simulamos la carga de datos
  //     await new Promise((resolve) => setTimeout(resolve, 400));
  //     setCargado(true);
  //   };
  //   cargarDatos();
  // }, []);

  // useEffect(() => {
  //   if (localStorage.getItem("dataInfoex") === null) {
  //     esHabilitado().then((data) => {
  //       if (!data.toString().startsWith("Error:")) {
  //         setINFOEX_Habilitado(data);
  //         localStorage.setItem("dataInfoex", JSON.stringify(data));
  //       } else {
  //         setError_INFOEX(true);
  //       }
  //     });
  //   } else {
  //     setINFOEX_Habilitado({
  //       habilitado: JSON.parse(localStorage.getItem("dataInfoex")).habilitado,
  //     });
  //   }
  //   // if (localStorage.getItem("dataIrpfHabiliciones") === null) {
  //   //   irpfHabilitado().then((data) => {
  //   //     if (!data.toString().startsWith("Error:")) {
  //   //       setIRPFHABILITACIONES_Habilitado(data);
  //   //       localStorage.setItem("dataIrpfHabiliciones", JSON.stringify(data));
  //   //     } else {
  //   //       setError_IRPFHABILITACIONES(true);
  //   //     }
  //   //   });
  //   // } else {
  //   //   setIRPFHABILITACIONES_Habilitado({
  //   //     habilitado: JSON.parse(localStorage.getItem("dataIrpfHabiliciones")).habilitado,
  //   //   });
  //   // }
  // }, []);

  return (
    <>
      <div className="container-fluid">
        <div className=""
          onClick={invokeCollapse}
          role="button"
          tabIndex={0}
          title="Desplegar mis consultas"
          aria-label="Desplegar mis consultas"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              invokeCollapse()
            }
          }}>
          {/* <TituloCaja
            tipo={"tituloModal dropdown-toggle link"}
            titulo={"Mis consultas"}
          ></TituloCaja>  */}
          <h2 className="tituloModal dropdown-toggle link">Mis consultas</h2>
        </div>
        {/* {!cargado ? (<>
          <Collapse in={isVisible}>
            <div id="collapsePanel">
              <div className="card-group d-flex flex-column flex-md-row row mt-4">
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <Placeholder />
                </div>
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <Placeholder />
                </div>

                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <Placeholder />
                </div>

                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <Placeholder/>
                </div>

              </div>
            </div>
          </Collapse>
        </>) : (<>
          <Collapse in={isVisible}>
            <div id="collapsePanel">
              <div className="card-group d-flex flex-column flex-md-row row">
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <NominaNoResumen></NominaNoResumen>
                </div>
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <IRPFNoResumen></IRPFNoResumen>
                </div>
                {error_IRPFHABILITACIONES ? (
                  <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                    <ErrorConexion titulo="Certificado IRPF por las habilitaciones"></ErrorConexion>
                  </div>
                ) : IRPFHABILITACIONES_habilitado?.habilitado ? (
                  <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                    <IRPFHabilitado></IRPFHabilitado>
                  </div>
                ) : IRPFHABILITACIONES_habilitado?.habilitado === null ? (
                  <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                    <Placeholder></Placeholder>
                  </div>
                ) : null}

                {error_INFOEX ? (
                  <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                    <ErrorConexion titulo="Certificación INFOEX"></ErrorConexion>
                  </div>
                ) : INFOEX_habilitado?.habilitado ? (
                  <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                    <InfoEx></InfoEx>
                  </div>
                ) : INFOEX_habilitado?.habilitado === null ? (
                  <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                    <Placeholder></Placeholder>
                  </div>
                ) : null}
              </div>
            </div>
          </Collapse>
        </>)} */}
        <Collapse in={isVisible}>
          <div id="collapsePanel">
            <div className="card-group d-flex flex-column flex-md-row row">
              <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <NominaNoResumen></NominaNoResumen>
              </div>
              <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <IRPFNoResumen></IRPFNoResumen>
              </div>
              {/* {error_IRPFHABILITACIONES ? (
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <ErrorConexion titulo="Certificado IRPF por las habilitaciones"></ErrorConexion>
                </div>
              ) : IRPFHABILITACIONES_habilitado?.habilitado ? (<>
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <IRPFHabilitado></IRPFHabilitado>
                </div>
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                  <IRPFHabilitadoNuevo></IRPFHabilitadoNuevo>
                </div>
              </>) : IRPFHABILITACIONES_habilitado?.habilitado === null ? (
                <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                 
                </div>
              ) : null} */}
              <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <IRPFHabilitadoNuevo></IRPFHabilitadoNuevo>
              </div>


              {error_INFOEX ? (<></>
                // <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                //   <ErrorConexion titulo="Certificación INFOEX"></ErrorConexion>
                // </div>
              ) : INFOEX_habilitado?.habilitado ? (<></>
                // <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                //   <InfoEx></InfoEx>
                // </div>
              ) : INFOEX_habilitado?.habilitado === null ? (<></>
                // <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                //   {/* <Placeholder></Placeholder> */}
                // </div>
              ) : null}
              <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <MisActosAdminCard />
              </div>
              {/*<div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <HojaServiciosPrestadosCard />
              </div>*/}
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};
export default MisDatos;
